module.exports = __webpack_public_path__ + "img/26.78f25945.jpg";